module.exports = __webpack_public_path__ + "img/design-crawl.2c298a8b.png";